import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getList(params) {
  return request({
    url: '/resourceRelease/findList',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function add(params) {
  return request({
    url: '/resourceRelease/save',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 */
export function updateState(params) {
    return request({
      url: '/resourceRelease/updateState',
      method: 'put',
      data: params
    })
  }
/**
 * 通过id删除
 */
export function del(id) {
    return request({
      url: `/resourceRelease/delete/${id}`,
      method: 'delete',
    })
  }
  /**
   * 查看详情
   */
  export function getInfoById(id) {
    return request({
      url: `/resourceRelease/${id}`,
      method: 'get'
    })
  }
